export const SIMILAR_PATIENT_URL = 'similarPatients/Patient/dynamicSearch/getSimilarPatientDetails';
export const SEARCH_SIMILAR_PATIENTS_URL = 'entity-tree/Patient_sp/search';

//Important: the filter-panel assumes having the '_' as a reserved character, we cannot use the real resource's ID which have this character
export const FILTER_TYPE: string = 'similarPatients'; //'Patient_sp';
export const FILTER_SUBTYPE: string = 'patientAnalytics';

export const SIMILAR_PATIENT_QUERY_BODY = (patientId) => {
  return {
    target: {
      _page: 0,
      _count: 'ALL'
    },
    filters: [
      {
        resource: 'Patient',
        value: patientId,
        path: '_id'
      }
      // {
      //   "path": "subResourceType",
      //   "type": "string",
      //   "value": "LESIONS.LUNG",
      //   "operator": "=",
      //   "resource": "LESIONSLUNG"
      // },
    ],
    recursiveGrouping: true,
    relations: [
      {
        path: 'context',
        child: 'Observation',
        _count: 'ALL',
        parent: 'Patient',
        cardinality: 'left',
        direction: '_revinclude'
      },
      // {
      //   path: 'context',
      //   child: 'Observation, LESIONSLUNG',
      //   _count: 'ALL',
      //   parent: 'Patient',
      //   cardinality: 'left',
      //   direction: '_revinclude'
      // },
      {
        path: 'context',
        child: 'Condition',
        _count: 'ALL',
        parent: 'Patient',
        cardinality: 'left',
        direction: '_revinclude'
      },
      {
        path: 'context',
        child: 'Event',
        _count: 'ALL',
        parent: 'Patient',
        cardinality: 'left',
        direction: '_revinclude'
      }
    ]
  };
};

// export const SIMILAR_PATIENT_QUERY_BODY = (patientId) => {
//   return {
//     target: {
//       _page: 0,
//       _count: 'ALL',
//       _fieldslist: 'id,{patient_study_information,cohort_name},gender,birthDate,{demographics,age}'
//     },
//     filters: [
//       {
//         resource: 'Patient',
//         value: patientId,
//         // value: 'ae46e6ac-a2b1-11ea-b79a-005056bccc4d' || patientId,
//         path: '_id'
//       }
//     ],
//     relations: [
//       {
//         path: 'context',
//         child: 'Observation',
//         _count: 'ALL',
//         parent: 'Patient',
//         direction: '_revinclude'
//       },
//       {
//         path: 'context',
//         child: 'Condition',
//         _count: 'ALL',
//         parent: 'Patient',
//         direction: '_revinclude'
//       },
//       {
//         path: 'context',
//         child: 'Event',
//         _count: 'ALL',
//         parent: 'Patient',
//         direction: '_revinclude'
//       }
//     ]
//   };
// };
